// extracted by mini-css-extract-plugin
export default {"basicInfoDiv":"validation_basicInfoDiv__y4HVf","basicInfoTitle":"validation_basicInfoTitle__gc0jp","observation":"validation_observation__A2TPc"};